import {
  Component,
  Input,
  OnChanges,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { Product, ProductsService } from '@vestiaire/api-sdk-angular';
import { descriptionDeviceMaxChar } from '@app/+product/components/product-description/description-device-max-char';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { isPlatformServer } from '@angular/common';

@Component({
  selector: 'vc-product-seller-description',
  templateUrl: './product-seller-description.component.html',
  styleUrls: ['./product-seller-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSellerDescriptionComponent implements OnInit, OnChanges {
  @Input()
  product: Product;

  public descriptionText: string;

  public maxChar = descriptionDeviceMaxChar.desktop;
  public descriptionMaxChar = this.maxChar;

  public translatable = true;
  public showTranslate = false;
  public isServer = false;
  public translatedDescription: string;

  constructor(
    private productService: ProductsService,
    private helperService: HelpersService,
    private changeDetector: ChangeDetectorRef,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isServer = isPlatformServer(platformId);
  }

  ngOnInit() {
    this.initAttributes();
  }

  ngOnChanges(changes) {
    if (changes['product'] && changes['product'].currentValue) {
      this.initAttributes();
    }
  }

  initAttributes() {
    if (this.product && this.product.description) {
      this.descriptionText = this.product.description;
      this.setDescriptionMaxChar();
    }
  }

  translate() {
    this.productService.translateProduct(this.product.id).subscribe(
      result => {
        if (result.data.translation) {
          this.translatedDescription = result.data.translation;
          this.displayTranslate();
        }
      },
      err => {
        this.translatable = false;
        this.changeDetector.markForCheck();
      }
    );
  }

  toggleDescriptionMaxChar() {
    this.descriptionMaxChar = this.descriptionMaxChar === this.maxChar ? this.descriptionText.length : this.maxChar;
  }

  toggleTranslation() {
    if (typeof this.translatedDescription === 'undefined') {
      this.translate();
    } else {
      this.displayTranslate();
    }
  }

  displayTranslate() {
    this.showTranslate = !this.showTranslate;
    this.descriptionText =
      this.showTranslate && this.translatedDescription ? this.translatedDescription : this.product.description;
    this.descriptionMaxChar = this.descriptionMaxChar !== this.maxChar ? this.descriptionText.length : this.maxChar;
    this.translatable = false;
    this.changeDetector.markForCheck();
  }

  setDescriptionMaxChar() {
    if (this.isServer) {
      // Do not truncate description in html
      this.maxChar = this.descriptionMaxChar = this.descriptionText.length;
      return;
    }

    this.maxChar = this.helperService.device.isSmOnly()
      ? descriptionDeviceMaxChar.mobile
      : descriptionDeviceMaxChar.desktop;
    this.descriptionMaxChar = this.maxChar;
  }

  public shouldDisplay(): boolean {
    if (!this.descriptionText) {
      return false;
    }

    if (this.product.localizedDescription) {
      // This key only exists if it's translated
      return true;
    }

    if (this.isServer) {
      // Do not display the translation in HTML if it's not translated
      return false;
    }

    return true;
  }
}
